import React from "react"
import PropTypes from "prop-types"
import { countries } from "country-flag-icons"
import getUnicodeFlagIcon from "country-flag-icons/unicode"

/** Country renders a small reference (short name, flag) to a given country, using 2-char ISO code. */
const Country = ({ iso, showCode = false }) => (
  <span>
    {showCode && <span>{iso}</span>}
    {countries.includes(iso) && <span>{getUnicodeFlagIcon(iso)}</span>}
  </span>
)

Country.propTypes = {
  iso: PropTypes.string,
  showCode: PropTypes.bool, // Indicates if the code should be shown along with the flag
}

export default Country
